import { render, staticRenderFns } from "./LessonList.vue?vue&type=template&id=22620bb5&scoped=true&"
import script from "./LessonList.vue?vue&type=script&lang=js&"
export * from "./LessonList.vue?vue&type=script&lang=js&"
import style0 from "./LessonList.vue?vue&type=style&index=0&id=22620bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22620bb5",
  null
  
)

export default component.exports